import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 9V3C7.5 2.44772 7.94772 2 8.5 2C9.05229 2 9.5 2.44772 9.5 3V9L9.49463 9.10205C9.4435 9.60639 9.01783 10 8.5 10C7.98218 10 7.5565 9.60639 7.50537 9.10205L7.5 9Z" fill="currentColor" />
      <path d="M2.5 9V3C2.5 2.44772 2.94772 2 3.5 2C4.05228 2 4.5 2.44772 4.5 3V9L4.49463 9.10205C4.4435 9.60639 4.01783 10 3.5 10C2.98217 10 2.5565 9.60639 2.50537 9.10205L2.5 9Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99992 12.0003V4.00033C9.99992 3.26395 10.5969 2.66699 11.3333 2.66699C12.0696 2.66699 12.6666 3.26395 12.6666 4.00033V12.0003L12.6594 12.1364C12.5912 12.8088 12.0237 13.3337 11.3333 13.3337C10.6428 13.3337 10.0753 12.8088 10.0071 12.1364L9.99992 12.0003Z" fill="currentColor" />
      <path d="M3.33325 12.0003V4.00033C3.33325 3.26395 3.93021 2.66699 4.66659 2.66699C5.40297 2.66699 5.99992 3.26395 5.99992 4.00033V12.0003L5.99276 12.1364C5.92458 12.8088 5.35702 13.3337 4.66659 13.3337C3.97615 13.3337 3.40859 12.8088 3.34041 12.1364L3.33325 12.0003Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5001 14.9997V4.99967C12.5001 4.0792 13.2463 3.33301 14.1667 3.33301C15.0872 3.33301 15.8334 4.0792 15.8334 4.99967V14.9997L15.8245 15.1698C15.7392 16.0103 15.0298 16.6663 14.1667 16.6663C13.3037 16.6663 12.5943 16.0103 12.509 15.1698L12.5001 14.9997Z" fill="currentColor" />
      <path d="M4.16675 14.9997V4.99967C4.16675 4.0792 4.91294 3.33301 5.83341 3.33301C6.75389 3.33301 7.50008 4.0792 7.50008 4.99967V14.9997L7.49113 15.1698C7.40591 16.0103 6.69646 16.6663 5.83341 16.6663C4.97037 16.6663 4.26092 16.0103 4.1757 15.1698L4.16675 14.9997Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 9V3C7.5 2.44772 7.94772 2 8.5 2C9.05229 2 9.5 2.44772 9.5 3V9L9.49463 9.10205C9.4435 9.60639 9.01783 10 8.5 10C7.98218 10 7.5565 9.60639 7.50537 9.10205L7.5 9Z" fill="currentColor" />
      <path d="M2.5 9V3C2.5 2.44772 2.94772 2 3.5 2C4.05228 2 4.5 2.44772 4.5 3V9L4.49463 9.10205C4.4435 9.60639 4.01783 10 3.5 10C2.98217 10 2.5565 9.60639 2.50537 9.10205L2.5 9Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99992 12.0003V4.00033C9.99992 3.26395 10.5969 2.66699 11.3333 2.66699C12.0696 2.66699 12.6666 3.26395 12.6666 4.00033V12.0003L12.6594 12.1364C12.5912 12.8088 12.0237 13.3337 11.3333 13.3337C10.6428 13.3337 10.0753 12.8088 10.0071 12.1364L9.99992 12.0003Z" fill="currentColor" />
      <path d="M3.33325 12.0003V4.00033C3.33325 3.26395 3.93021 2.66699 4.66659 2.66699C5.40297 2.66699 5.99992 3.26395 5.99992 4.00033V12.0003L5.99276 12.1364C5.92458 12.8088 5.35702 13.3337 4.66659 13.3337C3.97615 13.3337 3.40859 12.8088 3.34041 12.1364L3.33325 12.0003Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5001 14.9997V4.99967C12.5001 4.0792 13.2463 3.33301 14.1667 3.33301C15.0872 3.33301 15.8334 4.0792 15.8334 4.99967V14.9997L15.8245 15.1698C15.7392 16.0103 15.0298 16.6663 14.1667 16.6663C13.3037 16.6663 12.5943 16.0103 12.509 15.1698L12.5001 14.9997Z" fill="currentColor" />
      <path d="M4.16675 14.9997V4.99967C4.16675 4.0792 4.91294 3.33301 5.83341 3.33301C6.75389 3.33301 7.50008 4.0792 7.50008 4.99967V14.9997L7.49113 15.1698C7.40591 16.0103 6.69646 16.6663 5.83341 16.6663C4.97037 16.6663 4.26092 16.0103 4.1757 15.1698L4.16675 14.9997Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconPause: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"pause"} {...props} />
);
